import React, { useState, useCallback } from 'react';
import { Dictionary } from 'lodash';
import { AugmentedDevice } from 'shared/models';
import { DeviceTree } from './DeviceTree';
import { useParams } from 'util/reactRouterHooks';
import { HasDeviceId } from 'selectors/buildingsSelectors';
import { DeviceTreeFilter } from './DeviceTreeFilter';
import { DeviceTreeCommands } from './DeviceTreeCommands';

require('./DevicesPanel.css');

export type Props = {
    devices: Dictionary<AugmentedDevice>;
    onClickAdd(): void;
    onClickSchedule(id: string): void;
};

type ChangeFunction =
    (
        fnTypes: Dictionary<boolean>,
        fnStatuses: Dictionary<boolean>,
    ) => void;

export const DevicesPanel = ({ devices, onClickAdd, onClickSchedule }: Props) => {
    const { deviceId } = useParams<HasDeviceId>();

    const [ selectedDeviceTypes, setSelectedDeviceTypes ] = useState<Dictionary<boolean>>({});
    const [ selectedDeviceStatuses, setSelectedDeviceStatuses ] = useState<Dictionary<boolean>>({});
    
    const handleChange = useCallback<ChangeFunction>((types, statuses) => {
        setSelectedDeviceTypes(() => types);
        setSelectedDeviceStatuses(() => statuses);
    }, [ setSelectedDeviceTypes, setSelectedDeviceStatuses ]);

    return (
        <div
            id="devices-panel"
            className={ deviceId && deviceId !== 'new' ? 'collapsed' : 'expanded' }
        >
            <DeviceTree
                devices={ devices }
                onClickSchedule={ onClickSchedule }
                selectedDeviceTypes={ selectedDeviceTypes }
                selectedDeviceStatuses={ selectedDeviceStatuses }
            />
            <div>
                <DeviceTreeCommands
                    onClickAdd={ onClickAdd }
                />
                <DeviceTreeFilter
                    selectedDeviceTypes={ selectedDeviceTypes }
                    selectedDeviceStatuses={ selectedDeviceStatuses }
                    onChange={ handleChange }
                />
            </div>
        </div>
    );
};
